import Swiper from 'swiper';
import { Navigation, A11y } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/a11y';

import { getA11y } from '../../utils/swiper';

export function videosSlider() {
  const pageLang = document.querySelector("html").getAttribute("lang") || "en";
  const sliders = document.querySelectorAll('.swiper--videos');

  let sliderInstances = [];

  if (!sliders) return;

  // init
  // --------------------------------------------
  sliders.forEach((slider) => {
    const sliderSwiper = new Swiper(slider, {
      a11y: getA11y(pageLang),
      loop: false,
      spaceBetween: 24,
      slidesPerView: 'auto',
      centeredSlides: false,
      watchSlidesProgress: true,
      navigation: {
        nextEl: '.swiper-button-next-custom',
        prevEl: '.swiper-button-prev-custom'
      },
      modules: [Navigation, A11y],
    });
    sliderInstances.push(sliderSwiper);
  });
}
